export default {
  SET_PLACES (state, places) {
    state.places = places
  },
  REMOVE_RECORD (state, itemId) {
    const placeIndex = state.places.findIndex((u) => u.id === itemId)
    state.places.splice(placeIndex, 1)
  }
}
